import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from './components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from './components/ui/tabs';
import { Badge } from './components/ui/badge';
import GlobalFooter from './components/GlobalFooter';

const PartnerRestaurants = () => {
  const navigate = useNavigate();

  // Real restaurant data for India (Delhi restaurants)
  // Note: meals = number of meals contributed by this restaurant
  // Total target: 1500 meals across all restaurants (India: 1292, Singapore: 208)
  const indiaRestaurants = [
    { id: 1, name: "Shami's Fresh Grill Kababs", address: "Malviya Nagar, Delhi", cuisine: "Kababs", meals: 53, logo: "SF", emoji: "🍖", logoImage: "https://customer-assets.emergentagent.com/job_bda09b9d-abb6-44f4-a2b2-1261c7bbed21/artifacts/x9w9v5qo_shamins.png" },
    { id: 2, name: "Desmo", address: "Malviya Nagar, Delhi", cuisine: "Multi-Cuisine", meals: 49, logo: "DM", emoji: "🍽️", logoImage: "/restaurant-logos/desmo.png" },
    { id: 3, name: "Super Chai", address: "Chandni Chowk, Delhi", cuisine: "Beverages", meals: 37, logo: "SC", emoji: "☕", logoImage: "https://customer-assets.emergentagent.com/job_bda09b9d-abb6-44f4-a2b2-1261c7bbed21/artifacts/zbqrxb05_super%20chai.png" },
    { id: 4, name: "Ek Andaaz", address: "Shivalik Road, Delhi", cuisine: "Indian", meals: 71, logo: "EA", emoji: "🍛", logoImage: "https://customer-assets.emergentagent.com/job_bda09b9d-abb6-44f4-a2b2-1261c7bbed21/artifacts/b8ilx9by_Ek%20Andaaz.png" },
    { id: 5, name: "Perilicious", address: "Malviya Nagar, Delhi", cuisine: "Multi-Cuisine", meals: 44, logo: "PR", emoji: "🍴", logoImage: "https://customer-assets.emergentagent.com/job_bda09b9d-abb6-44f4-a2b2-1261c7bbed21/artifacts/rac3uxlh_perilicious.png" },
    { id: 6, name: "Suchali's Artisan Bake House", address: "Vasant Vihar, Delhi", cuisine: "Bakery", meals: 31, logo: "SA", emoji: "🥐", logoImage: "https://customer-assets.emergentagent.com/job_bda09b9d-abb6-44f4-a2b2-1261c7bbed21/artifacts/gv6kd0ot_suchalis.png" },
    { id: 7, name: "Nizams", address: "Malviya Nagar, Delhi", cuisine: "Mughlai", meals: 80, logo: "NZ", emoji: "🍲", logoImage: "https://customer-assets.emergentagent.com/job_bda09b9d-abb6-44f4-a2b2-1261c7bbed21/artifacts/sad92jlo_nizams.png" },
    { id: 8, name: "Mojo Pizza", address: "Malviya Nagar, Delhi", cuisine: "Pizza", meals: 72, logo: "MP", emoji: "🍕", logoImage: "https://customer-assets.emergentagent.com/job_bda09b9d-abb6-44f4-a2b2-1261c7bbed21/artifacts/r8ad02kd_mojo%20pizza.png" },
    { id: 9, name: "Box 8", address: "Malviya Nagar, Delhi", cuisine: "Fast Food", meals: 53, logo: "B8", emoji: "📦", logoImage: "/restaurant-logos/box8-new.png" },
    { id: 10, name: "Rudra Sweets", address: "Preet Vihar, Delhi", cuisine: "Sweets", meals: 43, logo: "RS", emoji: "🍬", logoImage: "https://customer-assets.emergentagent.com/job_bda09b9d-abb6-44f4-a2b2-1261c7bbed21/artifacts/mc3nt7fk_rudra%20sweet.png" },
    { id: 11, name: "Sardar Ji Bakhsh", address: "Malviya Nagar, Delhi", cuisine: "Punjabi", meals: 75, logo: "SJ", emoji: "🥘", logoImage: "https://customer-assets.emergentagent.com/job_bda09b9d-abb6-44f4-a2b2-1261c7bbed21/artifacts/skc7qz0c_sardar%20-%20ji%20-bakhsh.png" },
    { id: 12, name: "Hasty Testy", address: "Delhi", cuisine: "Fast Food", meals: 50, logo: "HT", emoji: "🍔", logoImage: "https://customer-assets.emergentagent.com/job_bda09b9d-abb6-44f4-a2b2-1261c7bbed21/artifacts/io6fwlcb_Hasty%20-%20Tasty.png" },
    { id: 13, name: "Oberoi Dhaba", address: "Mehrauli, Delhi", cuisine: "Dhaba", meals: 65, logo: "OD", emoji: "🍛", logoImage: "https://customer-assets.emergentagent.com/job_bda09b9d-abb6-44f4-a2b2-1261c7bbed21/artifacts/h8wae27v_oberoi%20dhaba.png" },
    { id: 14, name: "Zorko Brand of Food Loves", address: "Malviya Nagar, Delhi", cuisine: "Multi-Cuisine", meals: 43, logo: "ZK", emoji: "❤️", logoImage: "https://customer-assets.emergentagent.com/job_bda09b9d-abb6-44f4-a2b2-1261c7bbed21/artifacts/tt8ngaoe_zorko.png" },
    { id: 15, name: "Tanjore", address: "Green Park, Delhi", cuisine: "South Indian", meals: 59, logo: "TJ", emoji: "🥥", logoImage: "https://customer-assets.emergentagent.com/job_bda09b9d-abb6-44f4-a2b2-1261c7bbed21/artifacts/n3ianfhx_tanjore.png" },
    { id: 16, name: "Green Nox", address: "Malviya Nagar, Delhi", cuisine: "Health Food", meals: 37, logo: "GN", emoji: "🥗", logoImage: "https://customer-assets.emergentagent.com/job_bda09b9d-abb6-44f4-a2b2-1261c7bbed21/artifacts/uju4hwmw_greennox.png" },
    { id: 17, name: "Biriyani Blues", address: "Connaught Place, Delhi", cuisine: "Biryani", meals: 93, logo: "BB", emoji: "🍚", logoImage: "/restaurant-logos/biryani-blues-new.png" },
    { id: 18, name: "Beliram Degchiwala", address: "Greater Kailash, Delhi", cuisine: "North Indian", meals: 80, logo: "BD", emoji: "🍲", logoImage: "/restaurant-logos/beliram-degchiwala-v2.png" },
    { id: 19, name: "Dadar Retreat", address: "Dadar, Mumbai", cuisine: "Multi-Cuisine", meals: 65, logo: "DR", emoji: "🍽️", logoImage: "https://customer-assets.emergentagent.com/job_bda09b9d-abb6-44f4-a2b2-1261c7bbed21/artifacts/tcsptcny_dadar%20retreat.png" },
    { id: 20, name: "Sadhguru", address: "Umerkhadi, Mumbai", cuisine: "Indian", meals: 56, logo: "SG", emoji: "🍛", logoImage: "https://customer-assets.emergentagent.com/job_bda09b9d-abb6-44f4-a2b2-1261c7bbed21/artifacts/x53939qm_sadguru.png" },
    { id: 21, name: "Saibini Gomantak", address: "Mumbai", cuisine: "Goan", meals: 49, logo: "SG", emoji: "🥘", logoImage: "https://customer-assets.emergentagent.com/job_bda09b9d-abb6-44f4-a2b2-1261c7bbed21/artifacts/2oreei6a_saaybin%20gomntak.png" },
    { id: 22, name: "Kandeel", address: "Mumbai", cuisine: "Indian", meals: 53, logo: "KD", emoji: "🍲", logoImage: "https://customer-assets.emergentagent.com/job_bda09b9d-abb6-44f4-a2b2-1261c7bbed21/artifacts/l91gnqhq_kandeel.png" },
    { id: 23, name: "Masli", address: "Mumbai", cuisine: "Seafood", meals: 34, logo: "MS", emoji: "🦐", logoImage: "https://customer-assets.emergentagent.com/job_bda09b9d-abb6-44f4-a2b2-1261c7bbed21/artifacts/ecpnrofq_masli.png" }
  ];

  // Real restaurant data for Singapore
  // Singapore total: 208 meals
  const singaporeRestaurants = [
    { id: 12, name: "Adhik Elite Eats", address: "Kampong Ampat, Singapore", cuisine: "Multi-Cuisine", meals: 51, logo: "AE", emoji: "🍽️", logoImage: "https://customer-assets.emergentagent.com/job_bda09b9d-abb6-44f4-a2b2-1261c7bbed21/artifacts/53o45r2b_Abhik%20Elite%20Eats.png" },
    { id: 13, name: "Red Chillis", address: "Raffles Ave, Singapore", cuisine: "Asian", meals: 44, logo: "RC", emoji: "🌶️", logoImage: "https://customer-assets.emergentagent.com/job_bda09b9d-abb6-44f4-a2b2-1261c7bbed21/artifacts/ytmp6fqk_red%20chills.png" },
    { id: 14, name: "Salt & Pepper", address: "Jalan Sultan, Singapore", cuisine: "International", meals: 32, logo: "SP", emoji: "🧂", logoImage: "https://customer-assets.emergentagent.com/job_bda09b9d-abb6-44f4-a2b2-1261c7bbed21/artifacts/87kx0gcj_salt%20%26%20pepper.png" },
    { id: 15, name: "Masala Tandoor", address: "Singapore", cuisine: "Indian", meals: 43, logo: "MT", emoji: "🍢", logoImage: "/restaurant-logos/masala-tandoor-sg.png" },
    { id: 16, name: "Masala Mingle", address: "Singapore", cuisine: "Indian Fusion", meals: 38, logo: "MM", emoji: "🥘", logoImage: "/restaurant-logos/masala-mingle-sg.jpg" }
  ];

  // Calculate statistics
  const indiaStats = {
    totalRestaurants: indiaRestaurants.length,
    totalMeals: indiaRestaurants.reduce((sum, r) => sum + r.meals, 0),
    areas: [...new Set(indiaRestaurants.map(r => r.address ? r.address.split(',')[0] : r.city))].length
  };

  const singaporeStats = {
    totalRestaurants: singaporeRestaurants.length,
    totalMeals: singaporeRestaurants.reduce((sum, r) => sum + r.meals, 0),
    areas: [...new Set(singaporeRestaurants.map(r => r.address ? r.address.split(',')[0] : r.city))].length
  };

  const RestaurantCard = ({ restaurant }) => (
    <Card className="hover:shadow-xl transition-all duration-300 border-0 shadow-lg group">
      <CardContent className="p-6">
        <div className="flex flex-col items-center text-center space-y-4">
          {/* Restaurant Logo */}
          <div className="w-24 h-24 rounded-full flex items-center justify-center shadow-lg overflow-hidden bg-white border-2 border-gray-100">
            {restaurant.logoImage ? (
              <img 
                src={restaurant.logoImage} 
                alt={`${restaurant.name} logo`}
                className="w-20 h-20 object-contain"
                style={{ padding: '8px' }}
              />
            ) : (
              <div className="w-full h-full bg-gradient-to-br from-green-500 to-green-600 flex items-center justify-center">
                <span className="text-white font-bold text-2xl">{restaurant.logo}</span>
              </div>
            )}
          </div>
          
          {/* Restaurant Name */}
          <CardTitle className="text-xl group-hover:text-green-600 transition-colors font-semibold">
            {restaurant.name}
          </CardTitle>
          
          {/* Address */}
          <div className="flex items-center space-x-1 text-gray-600">
            <span className="text-lg">📍</span>
            <span className="text-base font-medium">{restaurant.address || restaurant.city}</span>
          </div>
        </div>
      </CardContent>
    </Card>
  );

  return (
    <div className="min-h-screen bg-gray-50">

      {/* Page Header */}
      <section 
        className="py-20 px-4 relative bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: 'url(/restaurants-banner.png)' }}
      >
        {/* Background overlay for better text readability */}
        <div className="absolute inset-0 bg-black bg-opacity-40"></div>
        
        <div className="container mx-auto px-4 max-w-6xl text-center relative z-10">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6 leading-tight drop-shadow-lg">
            Our Partner <span className="text-green-400">Restaurants</span>
          </h1>
          <p className="text-xl text-white max-w-3xl mx-auto leading-relaxed drop-shadow-md">
            Meet the restaurants joining us in reducing food waste and feeding communities. 
            Together, we're making a real impact across India and Singapore.
          </p>
        </div>
      </section>

      {/* Restaurant Listings */}
      <section className="py-16">
        <div className="container mx-auto px-4 max-w-6xl">
          <Tabs defaultValue="india" className="w-full">
            <div className="flex justify-center mb-12">
              <TabsList className="grid w-full max-w-md grid-cols-2">
                <TabsTrigger value="india" className="text-lg py-3" data-testid="india-tab">
                  🇮🇳 India Partners
                </TabsTrigger>
                <TabsTrigger value="singapore" className="text-lg py-3" data-testid="singapore-tab">
                  🇸🇬 Singapore Partners
                </TabsTrigger>
              </TabsList>
            </div>

            <TabsContent value="india" className="space-y-8">
              <div className="text-center mb-8">
                <h2 className="text-3xl font-bold text-gray-900 mb-4">India Partners</h2>
                <div className="flex justify-center space-x-8 text-sm text-gray-600">
                  <div>
                    <span className="font-semibold text-green-600">{indiaStats.totalRestaurants}</span> Restaurants
                  </div>
                  <div>
                    <span className="font-semibold text-green-600">{indiaStats.totalMeals.toLocaleString()}</span> Meals Donated
                  </div>
                  <div>
                    <span className="font-semibold text-green-600">{indiaStats.areas}</span> Areas
                  </div>
                </div>
              </div>
              
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {indiaRestaurants.map(restaurant => (
                  <RestaurantCard key={restaurant.id} restaurant={restaurant} />
                ))}
              </div>
            </TabsContent>

            <TabsContent value="singapore" className="space-y-8">
              <div className="text-center mb-8">
                <h2 className="text-3xl font-bold text-gray-900 mb-4">Singapore Partners</h2>
                <div className="flex justify-center space-x-8 text-sm text-gray-600">
                  <div>
                    <span className="font-semibold text-green-600">{singaporeStats.totalRestaurants}</span> Restaurants
                  </div>
                  <div>
                    <span className="font-semibold text-green-600">{singaporeStats.totalMeals.toLocaleString()}</span> Meals Donated
                  </div>
                  <div>
                    <span className="font-semibold text-green-600">{singaporeStats.areas}</span> Districts
                  </div>
                </div>
              </div>
              
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {singaporeRestaurants.map(restaurant => (
                  <RestaurantCard key={restaurant.id} restaurant={restaurant} />
                ))}
              </div>
            </TabsContent>
          </Tabs>
        </div>
      </section>

      {/* Statistics Section */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4 max-w-6xl">
          <h2 className="text-4xl font-bold text-center text-gray-900 mb-16">
            Impact by Region
          </h2>
          
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {/* India Stats */}
            <Card className="border-0 shadow-xl">
              <CardHeader className="text-center pb-6">
                <div className="text-6xl mb-4">🇮🇳</div>
                <CardTitle className="text-2xl">India Impact</CardTitle>
              </CardHeader>
              <CardContent className="space-y-6">
                <div className="grid grid-cols-3 gap-4">
                  <div className="text-center">
                    <div className="text-3xl font-bold text-green-600">{indiaStats.totalRestaurants}</div>
                    <div className="text-sm text-gray-600">Partner Restaurants</div>
                  </div>
                  <div className="text-center">
                    <div className="text-3xl font-bold text-blue-600">{indiaStats.totalMeals.toLocaleString()}</div>
                    <div className="text-sm text-gray-600">Meals Rescued</div>
                  </div>
                  <div className="text-center">
                    <div className="text-3xl font-bold text-purple-600">{indiaStats.areas}</div>
                    <div className="text-sm text-gray-600">Areas Covered</div>
                  </div>
                </div>
              </CardContent>
            </Card>

            {/* Singapore Stats */}
            <Card className="border-0 shadow-xl">
              <CardHeader className="text-center pb-6">
                <div className="text-6xl mb-4">🇸🇬</div>
                <CardTitle className="text-2xl">Singapore Impact</CardTitle>
              </CardHeader>
              <CardContent className="space-y-6">
                <div className="grid grid-cols-3 gap-4">
                  <div className="text-center">
                    <div className="text-3xl font-bold text-green-600">{singaporeStats.totalRestaurants}</div>
                    <div className="text-sm text-gray-600">Partner Restaurants</div>
                  </div>
                  <div className="text-center">
                    <div className="text-3xl font-bold text-blue-600">{singaporeStats.totalMeals.toLocaleString()}</div>
                    <div className="text-sm text-gray-600">Meals Rescued</div>
                  </div>
                  <div className="text-center">
                    <div className="text-3xl font-bold text-purple-600">{singaporeStats.areas}</div>
                    <div className="text-sm text-gray-600">Districts Covered</div>
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-green-600">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-4xl font-bold text-white mb-6">
            Want to Partner with Us?
          </h2>
          <p className="text-xl text-green-100 mb-8 max-w-2xl mx-auto">
            Join our network of partner restaurants and make a meaningful impact on food waste 
            while helping feed communities in need.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button 
              size="lg" 
              onClick={() => navigate('/auth')}
              className="bg-white text-green-600 hover:bg-gray-100 text-lg px-8 py-3"
              data-testid="partner-signup-btn"
            >
              Register as Restaurant
            </Button>
          </div>
        </div>
      </section>

      {/* Global Footer */}
      <GlobalFooter />
    </div>
  );
};

export default PartnerRestaurants;